
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
import { isNotEmpty } from '~/utils/common'
export default {
  props: ['onSlideNavigation', 'sildeStyle', 'isMobile', 'list', 'onClickBannerWapper', 'imgWidth'],
  data() {
    return {
      swiperObject: undefined,
      isReadyState: undefined,
      innerShow: false
    }
  },
  watch: {
    list(n, o) {
      if (n.length > 0) {
        setTimeout(() => {
          this.innerShow = true
        }, 100)
      } else {
        this.innerShow = false
      }
    },
    isMobile() {
      if (this.swiperObject) {
        this.swiperLoad()
      }
    }
  },
  created() {
    this.key = `${this.uuidv4()}`
  },
  mounted() {
    this.swiperLoad()
  },
  methods: {
    isNotEmpty,
    uuidv4() {
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
      return `swiper${uuid}`
    },
    swiperLoad() {
      if (this.isReadyState) {
        this.isReadyState = undefined
        this.innerShow = false
        setTimeout(() => {
          this.innerShow = true
        }, 500)
      }
      this.isReadyState = setInterval(() => {
        // console.log(document.querySelectorAll(`.${this.key}`).length)
        if (document.querySelectorAll(`.${this.key}`).length > 0) {
          this.swiperObject = new Swiper(`.${this.key}`, {
            lazy: true,
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            // slideToClickedSlide: true,
            navigation: {
              nextEl: `.${this.key}-next`,
              prevEl: `.${this.key}-prev`
            },
            pagination: {
              clickable: true,
              el: `.${this.key}-pagination`
            },
            autoplay: {
              delay: 2500,
              disableOnInteraction: false
            },
            on: {
              init() {
                console.log('refresh')
              }
              // slideChange() {
              //   console.log('slide changed')
              // },
              // click(swiper, event) {
              //   console.log(swiper, event)
              // },
              // slideNextTransitionStart() {
              //   console.log('slideNextTransitionStart')
              // }
            }
            // modules: [Navigation, Pagination, Autoplay]
          })
          clearInterval(this.isReadyState)
        }
      }, 100)
    }
  },
  destroy() {
    if (this.isReadyState !== undefined) {
      clearInterval(this.isReadyState)
    }
    if (this.swiperObject) {
      this.swiperObject = undefined
    }
  }
}
